/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Default_RoleInputs */



/**
* | output |
* | --- |
* | "Default role" |
*
* @param {Team_Manager_Import_Default_RoleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_default_role = /** @type {((inputs?: Team_Manager_Import_Default_RoleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Default_RoleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rôle par défaut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Standardrolle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ruolo predefinito")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Роль по умолчанию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rol predeterminado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("默认角色")
	if (locale === "ja") return /** @type {LocalizedString} */ ("既定の役割")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डिफ़ॉल्ट भूमिका")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Função predefinida")
	return /** @type {LocalizedString} */ ("Default role")
});